// ─────────────────────────────────────────────
//  pwaInstallSteps.js — Pasos para instalar la PWA
// ─────────────────────────────────────────────

export const INSTALL_PLATFORMS = [
	{
		id: 'ios',
		icon: '🍎',
		title: 'iPhone / iPad (Safari)',
		steps: [
			'Abre esta página en Safari (no funciona igual en Chrome ni en otros navegadores de iOS).',
			'Toca el botón Compartir en la barra inferior (cuadrado con flecha hacia arriba).',
			'Desplázate y elige «Agregar a pantalla de inicio».',
			'Confirma el nombre «AR Cuánto» y pulsa Agregar.',
			'Abre la app desde el ícono en tu pantalla de inicio.',
		],
	},
	{
		id: 'android',
		icon: '🤖',
		title: 'Android (Chrome)',
		steps: [
			'Abre esta página en Google Chrome.',
			'Toca el menú ⋮ en la esquina superior derecha.',
			'Elige «Instalar aplicación» o «Agregar a pantalla de inicio».',
			'Confirma en el diálogo y espera a que se instale.',
			'Abre AR Cuánto desde el ícono en tu pantalla de inicio o cajón de apps.',
		],
	},
];
